import React from "react";
import { useSelector } from "react-redux";
import {
    selectAllRegistration,
    updateRegistrationClassification,
} from "../../redux/slices/registrationSlice";
import { selectBaseUrl } from "../../redux/slices/p2pSettingsSlice";
import { selectAllClassifications } from "../../redux/slices/classificationsSlice";
import PreselectClassification from "./PreselectClassification";

const ConnectedPreselectClassification = () => {
    const registration = useSelector(selectAllRegistration);
    const {
        classification: { Classification = [] },
    } = registration;
    const baseUrl = useSelector(selectBaseUrl);
    const classifications = useSelector(selectAllClassifications);
    const getIsClassificationAvailable = (classificationId) => {
        const matchedClassification =
            classifications?.find(
                (_classification) =>
                    String(classificationId) === String(_classification.id),
            ) || {};

        const isClassificationAvailable =
            Object.keys(matchedClassification)?.length > 0;

        return isClassificationAvailable;
    };

    const preselectClassificationProps = {
        baseUrl,
        Classification,
        updateRegistrationClassification,
        getIsClassificationAvailable,
    };
    return <PreselectClassification {...preselectClassificationProps} />;
};

export default ConnectedPreselectClassification;
